import Cookies from 'js-cookie';

const app = {
  state: {
    themeColor: '#4764D4',
    themeGreen: '#41B883',
    sidebar: {
      opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
      withoutAnimation: false
    },
    device: 'desktop',
    realMobile: false,
    breadTitle: '',
    Privacy: 'https://maxain-bucket-prod.s3-accelerate.amazonaws.com/files/PrivacyPolicy.pdf',
    RiskStatement: 'https://maxain-bucket-prod.s3-accelerate.amazonaws.com/files/RiskDisclosureandWarningNotice.pdf',
    ToPreventMoneyLaundering: 'https://maxain-bucket-prod.s3-accelerate.amazonaws.com/files/AntiMoneyLaunderingAgreement.pdf',
    safety_instructions: 'https://maxain-bucket-prod.s3-accelerate.amazonaws.com/files/AccountFundsSecurityStatement.pdf',
    listRefresh: false,// 列表刷新

  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      state.sidebar.opened = !state.sidebar.opened;
      state.sidebar.withoutAnimation = false;
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 0);
      state.sidebar.opened = false;
      state.sidebar.withoutAnimation = withoutAnimation;
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device;
    },
    setMenuTitle: (state, title) => {
      state.breadTitle = title;
    },
    setRealMobile: (state, flag) => {
      state.realMobile = flag;
    },
    setListRefresh: (state, flag) => {
      state.listRefresh = flag;
    },
  },
  actions: {
    toggleSideBar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    },
    closeSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    toggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    }
  },
  getters:{
    sidebar: state => state.sidebar,
    device: state => state.device,
    breadTitle: state => state.breadTitle,
    Privacy: state => state.Privacy,
    RiskStatement: state => state.RiskStatement,
    ToPreventMoneyLaundering: state => state.ToPreventMoneyLaundering,
    safety_instructions: state => state.safety_instructions,

    realMobile: state => state.realMobile,
    listRefresh: state => state.listRefresh,
    themeColor: state => state.themeColor,
    themeGreen: state => state.themeGreen,
  }
};

export default app;
